import { motion } from "framer-motion";

/**
 * StaggeredList — wrap a list of children to get the brand's signature
 * staggered fade-up entry. Use <Stagger.Item> for each child.
 */
const containerVariants = {
  hidden: { opacity: 1 },
  show: {
    opacity: 1,
    transition: { staggerChildren: 0.07, delayChildren: 0.05 },
  },
};

const itemVariants = {
  hidden: { opacity: 0, y: 18 },
  show: {
    opacity: 1,
    y: 0,
    transition: { type: "spring", stiffness: 240, damping: 24 },
  },
};

export function Stagger({ children, className = "", as = "div", ...rest }) {
  const Comp = motion[as] || motion.div;
  return (
    <Comp
      variants={containerVariants}
      initial="hidden"
      animate="show"
      className={className}
      {...rest}
    >
      {children}
    </Comp>
  );
}

Stagger.Item = function StaggerItem({ children, className = "", as = "div", ...rest }) {
  const Comp = motion[as] || motion.div;
  return (
    <Comp variants={itemVariants} className={className} {...rest}>
      {children}
    </Comp>
  );
};
